/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { V2_AppHeader } from "../../../../../app/components/header/V2component_Header/V2_AppHeader";
import { NewUI_AppHeader } from "../../../../../app/components/header/NewUI_component_Header/NewUI_AppHeader";

/**
 * Extracted from V2_Shell.tsx — renderAppHeader (Zero Logic Change)
 * Props = every variable the original JSX block referenced from parent scope.
 */
export interface ShellHeaderProps {
  showFabricComponent: boolean;
  onFabricVisibilityChanged: (isVisible: boolean) => void;
  locales: any;
  dispatchUpdateLocaleAction: (locale: any) => void;
  isAppReady: boolean;
  theme: any;
  appName: string;
  isUserLoggedIn: boolean;
  user: any;
  currentUserData: any;
  getUserIDByEmailId: (...args: any[]) => any;
  handleChatBotIconClick: (...args: any[]) => void;
  hideIrisBot: () => void;
  selectedActiveTab: string;
  isIrisLoader: boolean;
  isPrompt: boolean;
  isFeedbackTab: boolean;
  isMCAPSCopilotEnabled: boolean;
}

export const ShellHeader: React.FC<ShellHeaderProps> = (props) => {
  return (
    <V2_AppHeader
      showFabricComponent={props.showFabricComponent}
      onFabricVisibilityChanged={props.onFabricVisibilityChanged}
      locales={props.locales}
      dispatchUpdateLocaleAction={props.dispatchUpdateLocaleAction}
      isAppReady={props.isAppReady}
      theme={props.theme}
      appName={props.appName}
      isUserLoggedIn={props.isUserLoggedIn}
      user={props.user}
      currentUserData={props.currentUserData}
      getUserIDByEmailId={props.getUserIDByEmailId}
      handleChatBotIconClick={props.handleChatBotIconClick}
      hideIrisBot={props.hideIrisBot}
      selectedActiveTab={props.selectedActiveTab}
      isIrisLoader={props.isIrisLoader}
      isPrompt={props.isPrompt}
      isFeedbackTab={props.isFeedbackTab}
      isMCAPSCopilotEnabled={props.isMCAPSCopilotEnabled}
    />
  );
};

/**
 * Extracted from V2_Shell.tsx — renderAppHeader_V2_Demo (Zero Logic Change)
 */
export interface ShellHeaderV2DemoProps {
  showFabricComponent: boolean;
  onFabricVisibilityChanged: (isVisible: boolean) => void;
  locales: any;
  dispatchUpdateLocaleAction: (locale: any) => void;
  isAppReady: boolean;
  theme: any;
  appName: string;
  isUserLoggedIn: boolean;
  user: any;
  currentUserData: any;
  getUserIDByEmailId: (...args: any[]) => any;
  handleChatBotIconClick: (...args: any[]) => void;
  selectedActiveTab: string;
  isIrisLoader: boolean;
  isPrompt: boolean;
}

export const ShellHeaderV2Demo: React.FC<ShellHeaderV2DemoProps> = (props) => {
  return (
    <NewUI_AppHeader
      showFabricComponent={props.showFabricComponent}
      onFabricVisibilityChanged={props.onFabricVisibilityChanged}
      locales={props.locales}
      dispatchUpdateLocaleAction={props.dispatchUpdateLocaleAction}
      isAppReady={props.isAppReady}
      theme={props.theme}
      appName={props.appName}
      isUserLoggedIn={props.isUserLoggedIn}
      user={props.user}
      currentUserData={props.currentUserData}
      getUserIDByEmailId={props.getUserIDByEmailId}
      handleChatBotIconClick={props.handleChatBotIconClick}
      selectedActiveTab={props.selectedActiveTab}
      isIrisLoader={props.isIrisLoader}
      isPrompt={props.isPrompt}
    />
  );
};
